import { createCheckers } from "ts-interface-checker";
import rootTi from "./Root-ti";
import userTi from "./User-ti";
import chatTi from "./Chat-ti";

export const { Root, Chat } = createCheckers(rootTi, chatTi, userTi);
